import { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap-v5';
import { LISTA_ESTADOS, TIPO_CALENDARIO } from "../../utils/Constants";
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from "clsx";
import { IMunicipioIBGE } from "../../interfaces/IMunicipioIBGE";
import IBGEService from "../../services/IBGEService";

const CalendarioModal = ({ toggleModal, importar, show }: { toggleModal: () => void, importar: (file: any) => void, show: boolean }) => {
    
    const [municipios, setMunicipios] = useState<IMunicipioIBGE[]>([]);
    const calendarioSchema = Yup.object().shape({
        nomeCalendario: Yup.string().min(3, 'Minimo 3 caracteres').max(50, 'Maximo 50 caracteres').required('Nome é obrigatório'),
        tipo: Yup.string().oneOf([TIPO_CALENDARIO.NACIONAL, TIPO_CALENDARIO.ESTADUAL, TIPO_CALENDARIO.MUNICIPAL]).required('Tipo calendário é obrigatório'),
        estado: Yup.string().max(2).min(2).test('validacao-estado', 'Estado somente é obrigatório quando tipo de Calendário é Estadual ou Municipal', value => {
            if (formik.values.tipo === TIPO_CALENDARIO.NACIONAL) {
                return true;
            }

            if (value?.length) {
                return true;
            }

            return false;
        }),
        municipio: Yup.string().min(3).test('validacao-municipal', 'Municipio somente é obrigatório quando tipo de Calendário é Municipal', value => {
            if (formik.values.tipo !== TIPO_CALENDARIO.MUNICIPAL) {
                return true;
            }

            if (formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL && value) {
                return true;
            } else {
                return false;
            }
        })
    })
    const initialValues = {
        nomeCalendario: '',
        tipo: '',
        estado: '',
        municipio: '',
        file: null as any
    }
    const formik = useFormik({
        initialValues,
        validationSchema: calendarioSchema,
        onSubmit: async (values, { setSubmitting }) => {
            importar(values);
            setSubmitting(false)
        }
    })

    useEffect(() => {
        formik.resetForm();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title titulo-modal">Importar Calendário</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}/>
                </div>
            </div>
            <div className="modal-body">
                <form className="row g-3">
                    <div className="col-md-8">
                        <label htmlFor="form-evento-nomedocalendario" className="form-label required">Nome do Calendário</label>
                        <input
                            {...formik.getFieldProps('nomeCalendario')} name="nomeCalendario" placeholder="Digite Algo" type="text"
                            className={clsx(
                                'form-control',
                                {
                                    'is-invalid': formik.touched.nomeCalendario && formik.errors.nomeCalendario
                                },
                                {
                                    'is-valid': formik.touched.nomeCalendario && !formik.errors.nomeCalendario
                                }
                            )} id="form-evento-nomedocalendario"
                        />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="form-calendario-tipoferiado" className="form-label required">Tipos de Feriados</label>
                        <select
                            {...formik.getFieldProps('tipo')} name="tipo"
                            id="form-calendario-tipoferiado"
                            onChange={async e => {
                                await formik.setFieldValue(e.target.name, e.target.value);
                                formik.setFieldTouched(e.target.name, true);

                                formik.setFieldValue('estado', '');
                                formik.setFieldTouched('estado', false);

                                formik.setFieldValue('municipio', '');
                                formik.setFieldTouched('municipio', false);

                                setMunicipios([]);
                            }}
                            className={clsx(
                                'form-select',
                                {
                                    'is-invalid': formik.touched.tipo && formik.errors.tipo
                                },
                                {
                                    'is-valid': formik.touched.tipo && !formik.errors.tipo
                                }
                            )}>

                            <option value="" hidden>Selecione</option>
                            <option value={TIPO_CALENDARIO.NACIONAL}>{TIPO_CALENDARIO.NACIONAL}</option>
                            <option value={TIPO_CALENDARIO.ESTADUAL}>{TIPO_CALENDARIO.ESTADUAL}</option>
                            <option value={TIPO_CALENDARIO.MUNICIPAL}>{TIPO_CALENDARIO.MUNICIPAL}</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="form-calendario-estados" className="form-label">Estado</label>
                        <select disabled={!(formik.values.tipo !== '' && formik.values.tipo !== TIPO_CALENDARIO.NACIONAL)} {...formik.getFieldProps('estado')} placeholder="Estado(UF)" id="form-calendario-estados"
                            onChange={async e => {
                                await formik.setFieldValue('estado', e.target.value);
                                if (e.target.value && formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL) {
                                    await IBGEService.pesquisarMunicipios(e.target.value, x => setMunicipios(x));
                                }
                            }}

                            className={clsx(
                                'form-select',
                                {
                                    'is-invalid': formik.touched.estado && formik.errors.estado
                                },
                                {
                                    'is-valid': formik.touched.estado && !formik.errors.estado
                                }
                            )}>
                            <option value="" hidden>Estado(UF)</option>
                            {
                                LISTA_ESTADOS.map((x, index) => <option value={x} key={index}>{x}</option>)
                            }
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="form-calendario-municipio" className="form-label">Município</label>
                        <select disabled={!(formik.values.tipo === TIPO_CALENDARIO.MUNICIPAL) || formik.values.estado === ''} {...formik.getFieldProps('municipio')} placeholder="municipio" id="form-calendario-municipio" 
                        className={clsx(
                            'form-select',
                            {
                                'is-invalid': formik.touched.municipio && formik.errors.municipio
                            },
                            {
                                'is-valid': formik.touched.municipio && !formik.errors.municipio
                            }
                        )}>
                            <option value="" hidden>Município</option>
                            {
                                municipios.map((x, index) => <option  key={index} value={x.nome}>{x.nome}</option>)
                            }
                        </select>
                    </div>
                    <input accept=".csv" style={{ display: 'none' }} id="inputFile" type="file" onChange={e => {
                        if (e.target.files !== null && e.target.files.length > 0) {
                            const file = e.target.files[0];
                            formik.setFieldValue('file', file);
                        }
                    }} />
                    <div onClick={() => {
                        const input = document.getElementById("inputFile");
                        formik.setFieldValue('file', null);
                        input?.click();
                    }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer' }}>
                        <div className="dropzone " id="upload">
                            <div className="mt-5 mb-5">

                                {
                                    formik.values.file ? 
                                        <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '24px' }}> {formik.values.file.name}</span>
                                    :
                                        <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '24px' }}>
                                            <i className="fas fa-upload fs-2x azul-agriholmes"/>
                                            Enviar Arquivo
                                        </span>
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button onClick={toggleModal} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
                <button disabled={formik.isSubmitting || !formik.isValid || !formik.values.file} onClick={() => formik.submitForm()} type="button" className="btn btn-primario ms-5"> SALVAR </button>
            </div>
        </div>
    </Modal>
}

export default CalendarioModal;